import {React,useState, useEffect} from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import RadialChart1 from "./userpanelChart1";
import RadialChart2 from "./userpanelChart2";
import RadialChart3 from "./userpanelChart3";



const UserPanel = () => {
  const[allOrders, setAllorders] = useState([]);
  const [deliveredOrders, setDeliveredorders] = useState([]);
  const [thisMonthdeliveredorders, setThismonthdeliveredorders]=useState([]);
  const [lastMonthdeliveredorders, setLastmonthdeliveredorders] = useState([]);
  const [deliveredPercent, setDeliveredpercent] = useState('')
  const[thisMonthorders,setThismonthorders] = useState([]);
  const[lastMonthorders, setLastmonthorders] = useState([]);
  const[ordersPercent, setOrderspercent] = useState('');
  const[storeID, setStoreid] = useState("");
  const[email,setEmail] = useState('');
  const[todayPendingorders, setTodaypendingorders] = useState([]);
  const[allPendingorders, setAllpendingorders] = useState([]);
  const[thisMonthcustomers, setThismonthcustomers] = useState([]);
  const[lastMonthcustomers, setLastmonthcustomers] = useState([]);
  const[allCustomers, setAllcustomers] = useState([])
  const[customerPercent, setCustomerspercent] = useState([]);
  const currentDate = new Date();
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Get the current month index and then get the name from the array
  const currentMonth = monthNames[currentDate.getMonth()];
  const [midnightTime, setMidnightTime] = useState(null);

useEffect(() => {
  const getMidnightTime = () => {
    const now = new Date();
    
    // Create a new date at 00:01 AM of the current day
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 1, 0, 0);
    
    // Convert to milliseconds since epoch
    const midnightTimeInMs = midnight.getTime();
    
    setMidnightTime(midnightTimeInMs);
  };

  getMidnightTime();
}, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])

  useEffect(()=>{
    const fetchData = async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAllorders?store=${storeID}`);
      const data = await res.json();
      setAllorders(data)
    }

    const fetchAllcustomers = async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAllcustomers?store=${storeID}`);
      const data = await res.json();
      setAllcustomers(data)
    }

    const fetchDeliveredorders = async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAlldeliveredorders?store=${storeID}`);
      const data = await res.json();
      setDeliveredorders(data)
    }
    const fetchPendingorders = async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAllpendingorders?store=${storeID}`);
      const data = await res.json();
      setAllpendingorders(data)
    }

    const fetchThismonthorders =async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getCurrentmonthorders?store=${storeID}`);
      const data = await res.json();
      setThismonthorders(data)
    }

    const fetchThismonthcustomers =async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getCurrentmonthcustomers?store=${storeID}`);
      const data = await res.json();
      setThismonthcustomers(data)
    }


    const fetchThismonthdeliveredorders =async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getCurrentmonthdeliveredorders?store=${storeID}`);
      const data = await res.json();
      setThismonthdeliveredorders(data)
    }

    const fetchLastmonthorders =async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getPreviousmonthorders?store=${storeID}`);
      const data = await res.json();
      setLastmonthorders(data)
    }
    const fetchLastmonthcustomers =async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getPreviousmonthcustomers?store=${storeID}`);
      const data = await res.json();
      setLastmonthcustomers(data)
    }


    const fetchLastmonthdeliveredorders =async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getPreviousmonthdeliveredorders?store=${storeID}`);
      const data = await res.json();
      setLastmonthdeliveredorders(data)
    }

    if(storeID){
      fetchData();
      fetchThismonthorders();
      fetchLastmonthorders();
      fetchDeliveredorders();
      fetchThismonthdeliveredorders();
      fetchLastmonthdeliveredorders();
      fetchPendingorders();
      fetchLastmonthcustomers();
      fetchThismonthcustomers();
      fetchAllcustomers();
    }

  },[storeID])

  useEffect(()=>{
    const fetchData=async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getPendingorderstoday?store=${storeID}&today=${midnightTime}`);
      const data = await res.json();
      setTodaypendingorders(data)
    }

    if(storeID && midnightTime){
      fetchData();
    }

  },[storeID,midnightTime])

  useEffect(()=>{
    var last;
    if(lastMonthorders.length == 0){
      last = 1;
    }
    if(lastMonthorders.length !== 0){
      last =  lastMonthorders.length
    }
    const current = thisMonthorders.length;


    const percent=((current-last)/last)*100;
    setOrderspercent(percent)
  },[thisMonthorders,lastMonthorders])

  useEffect(()=>{
    var last;
    if(lastMonthdeliveredorders.length == 0){
      last = 1;
    }
    if(lastMonthdeliveredorders.length !== 0){
      last = lastMonthdeliveredorders.length;
    }
    const current = thisMonthdeliveredorders.length;
    const percent = ((current-last)/last)*100;
    if(percent == -100){
      setDeliveredpercent(0)
    }
    if(percent !== -100){
      setDeliveredpercent(percent)
    }
   

  },[thisMonthdeliveredorders,lastMonthdeliveredorders])



  useEffect(()=>{
    var last;
    if(lastMonthcustomers.length == 0){
      last = 1;
    }
    if(lastMonthcustomers.length !== 0){
      last = lastMonthcustomers.length;
    }
    const current = thisMonthcustomers.length;
    const percent = ((current-last)/last)*100;
    if(percent == -100){
      setCustomerspercent(0)
    }
    if(percent !== -100){
      setCustomerspercent(percent)
    }
   

  },[thisMonthcustomers,lastMonthcustomers])

  return (
    <div>
      <div className='usepanel' >
      <div className="usepanelCards">
      
          <Card className='crd' style={{backgroundColor:'#80ffaa'}}>
           
            <CardBody>
              <div className="d-flex text-muted">
               

                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="mb-1">{currentMonth} orders</h5>
                  <h5 className="mb-3">{allOrders.length}</h5>
                  {/* <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {ordersPercent}%{" "}
                      <i className="ri-arrow-right-up-line align-bottom ms-1"></i>
                    </span>{" "}
                
                  </p> */}
                  <p>All orders: {allOrders.length}</p>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className='crd' style={{backgroundColor:'#80d9ff'}}>
            <CardBody>
              <div className="d-flex">
                

                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="mb-1">{currentMonth} Delivered</h5>
                  <h5 className="mb-3">{thisMonthdeliveredorders.length}</h5>
                  {/* <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {" "}
                      1.7%{" "}
                      <i className="ri-arrow-right-up-line align-bottom ms-1"></i>
                    </span>{" "}
                    From previous
                  </p> */}
                  <p>All delivered orders: {deliveredOrders.length}</p>
                </div>
              </div>
            </CardBody>
          </Card>
     

      </div>
        <div className="usepanelCards">
    
          <Card className='crd' style={{backgroundColor:'#ff5c6c'}}>
            <CardBody>
              <div className="d-flex text-muted">
                {/* <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart3
                    id="radialchart-3"
                    className="apex-charts"
                    dir="ltr"
                  />
                </div> */}

                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="mb-1">Pending orders today</h5>
                  <h5 className="mb-3">{todayPendingorders.length}</h5>
                 
                  <p>All pending orders: {allPendingorders.length}</p>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className='crd' style={{backgroundColor:'#ffb05c'}}>
            <CardBody>
              <div className="d-flex text-muted">
                
                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="mb-1">New customers</h5>
                  <h5 className="mb-3">{(thisMonthcustomers.length)-(lastMonthcustomers.length)}</h5>
                  <p>All customers: {allCustomers.length} </p>
                </div>
              </div>
            </CardBody>
          </Card>
   

        </div>

       
      </div>
    </div>
  );
};

export default UserPanel;
